import { render, staticRenderFns } from "./BlockTabs.vue?vue&type=template&id=94ec07ce&scoped=true&"
import script from "./BlockTabs.vue?vue&type=script&lang=ts&"
export * from "./BlockTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTabs.vue?vue&type=style&index=0&id=94ec07ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ec07ce",
  null
  
)

export default component.exports